import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Box, Avatar, Accordion, AccordionSummary, AccordionDetails, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Breadcrumbs, Link } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { Typography, Card, Chip, IconButton, CardContent, Tooltip as TooltipCustom, useMediaQuery, Backdrop, CircularProgress, useTheme, Stack } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMaterialUIController, setMiniSidenav } from "context";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import Banner1 from "assets/images/Distributors/KDP_new_logo11.jpg";
import KpiMetricscards from "components/KPI/KpiMetricscards";
import TimeSeriescards from "components/TimeSeries/TimeSeriescards";
import HighlightsCards from "components/Highlights/Highlightscard";
import PieLegendCard from "components/Visualizations/Piecharts";
import Map from "components/Visualizations/Map";
import Barcharts from "components/Visualizations/Barcharts";
import LineChartSubBrand from "components/Visualizations/Linechartsubbrand";
import TopSkuBarChart from "components/Visualizations/SkuBarchart";
import InventoryCharts from "components/Visualizations/Inventorycharts";
import MultiBarcharts from "components/Visualizations/MultiBarcharts";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import FilterChip from "components/FilterChip/FilterChip";
import CountyCoverageMap from "components/Visualizations/CountyMap";
import StateCountyCoverageMap from "components/StateCountyCoverageMap/StateCountyCoverageMap";
import "../RetailsNetwork/retails.css";
import Datamap from "./Datamap";
import { fetchDistributors } from "services/distributors.service";

import { getTimeSeriesLabels } from "../../../components/TimeSeries/monthUtils";

function DistributorsDetailspage({ subcategoryToken }) {
  const { lastYearSameMonth, currentMonthLabel, prevMonthLabel } = getTimeSeriesLabels();

  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const location = useLocation();
  const selectedItem = location?.state?.selectedItem || null;
  const distributorUIData = location?.state?.distributorUIData || [];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Below 900px
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg")); // Between 900px and 1200px
  const [distributorData, setdistributorData] = useState(null);
  // State for API data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const header = document.querySelector(".MuiAppBar-root");
    if (header) {
      header.style.display = "none";
    }
  }, []);

  // Toggle sidenav from the page menu icon
  const isTogglingSidenavRef = useRef(false);
  const handleToggleSidenav = useCallback(() => {
    if (isTogglingSidenavRef.current) return;
    isTogglingSidenavRef.current = true;
    // Defer to next frame to avoid blocking heavy charts paint
    requestAnimationFrame(() => {
      setMiniSidenav(dispatch, !miniSidenav);
      setTimeout(() => {
        isTogglingSidenavRef.current = false;
      }, 150);
    });
  }, [dispatch, miniSidenav]);

  console.log("Rendering Distributors Details Page", miniSidenav);

  // useEffect(() => {
  //     const fetchAllData = async () => {
  //         try {
  //             setLoading(true);
  //         } catch (error) {
  //             console.error('Failed loading static mocks or transforming data:', error);
  //             setError('Failed to load static mock data. Check competitive_analysis/data/allMocks.json');
  //         } finally {
  //             setLoading(false);
  //         }
  //     };

  //     fetchAllData();
  // });

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);

        const distributorResponse = await fetchDistributors();
        const distributorItem = distributorResponse || null;

        setdistributorData(distributorItem);
        console.log(distributorItem, "testtest");
      } catch (error) {
        console.error("Failed loading my dashboard data:", error);
        setError("Failed to load my dashboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []); // Removed myDashboardData dependency

  const stateMap = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  };
  const [formateddata, setformateddata] = useState([]);
  useEffect(() => {
    const formatted = Datamap.map((item) => ({
      ...item,
      stateName: stateMap[item.State],
    }));

    setformateddata(formatted);
  }, []);

  console.log(formateddata, "####");

  const rows1 = [
    { region: "South", state: "Florida", country: "Miami-Dade", zipCode: "33132", numberOfStores: "34" },
    { region: "South", state: "Florida", country: "Miami-Dade", zipCode: "33132", numberOfStores: "12" },
    { region: "South", state: "Florida", country: "Pasco", zipCode: "33132", numberOfStores: "45" },
    { region: "South", state: "Florida", country: "Pasco", zipCode: "33132", numberOfStores: "29" },
    { region: "South Central", state: "Texas", country: "Travis County", zipCode: "33132", numberOfStores: "32" },
    { region: "South Central", state: "Texas", country: "Galveston", zipCode: "33132", numberOfStores: "46" },
    { region: "South Central", state: "Texas", country: "Denton County", zipCode: "33132", numberOfStores: "53" },
  ];

  const accordionData = [
    {
      title: "Distributor Overview",
      doors: "12,345",
      status: "Active",
      RegionsServed: distributorData?.distributorList?.items?.regionsServed,
      stateserved: ["AL", "AR", "AZ", "CA", "CO", "FL", "GA", "IA", "IL", "IN", "KS", "KY", "LA", "MI", "MO", "MS", "NC", "NE", "NM", "NV", "OH", "OK", "OR", "PA", "SC", "SD", "TN", "TX", "VA", "WA", "WI"],
      AssignmentType: "Direct DP",
      KDPFlag: distributorData?.distributorList?.items?.kdpFlag,
    },
  ];
  const [expanded, setExpanded] = useState("panel0");
  const [activeIdx, setActiveIdx] = React.useState(0);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const metricData = [
    { title: "Distributor Sales Rank", value: "#2", growth: "1" },
    { title: "Distributors Sales Share", value: "34%", growth: "12%" },
    { title: "Total Points of Distribution", value: "12,345", growth: "233" },
    { title: "Active SKUs", value: "22", growth: "8" },
  ];

  const formatToMillions = (value) => {
    return value == null || value === "-" ? "-" : (Number(value) / 1_000_000).toFixed(1);
  };

  const truncateDecimal = (num, decimals = 1) => {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  };

  const Kpiscardsdata = [
    {
      title: "Reported Dollars Sold",
      values: [
        {
          label: "MTD",
          change: distributorData?.distributorReportedDollarSolds?.items?.cMvsGoal ? `${distributorData?.distributorReportedDollarSolds?.items?.cMvsGoal}%` : "0%",
          changely: distributorData?.distributorReportedDollarSolds?.items?.cMvsLM ? `${distributorData?.distributorReportedDollarSolds?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: distributorData?.distributorReportedDollarSolds?.items?.cQvsGoal ? `${distributorData?.distributorReportedDollarSolds?.items?.cQvsGoal}%` : "0%",
          changely: distributorData?.distributorReportedDollarSolds?.items?.cQvsLQ ? `${distributorData?.distributorReportedDollarSolds?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: distributorData?.distributorReportedDollarSolds?.items?.cYvsGoal ? `${distributorData?.distributorReportedDollarSolds?.items?.cYvsGoal}%` : "0%",
          changely: distributorData?.distributorReportedDollarSolds?.items?.cYvsLY ? `${distributorData?.distributorReportedDollarSolds?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.currentYear)}M`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Reported Units Sold (Cases)",
      values: [
        {
          label: "MTD",
          change: distributorData?.distributorReportedUnitsSolds?.items?.cMvsGoal ? `${distributorData?.distributorReportedUnitsSolds?.items?.cMvsGoal}%` : "0%",
          changely: distributorData?.distributorReportedUnitsSolds?.items?.cMvsLM ? `${distributorData?.distributorReportedUnitsSolds?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: distributorData?.distributorReportedUnitsSolds?.items?.cQvsGoal ? `${distributorData?.distributorReportedUnitsSolds?.items?.cQvsGoal}%` : "0%",
          changely: distributorData?.distributorReportedUnitsSolds?.items?.cQvsLQ ? `${distributorData?.distributorReportedUnitsSolds?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: distributorData?.distributorReportedUnitsSolds?.items?.cYvsGoal ? `${distributorData?.distributorReportedUnitsSolds?.items?.cYvsGoal}%` : "0%",
          changely: distributorData?.distributorReportedUnitsSolds?.items?.cYvsLY ? `${distributorData?.distributorReportedUnitsSolds?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.currentYear)}M`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Inventory Turnover (Units)",
      values: [
        {
          label: "MTD",
          change: distributorData?.distributorInventoryTurnovers?.items?.cMvsGoal ? `${distributorData?.distributorInventoryTurnovers?.items?.cMvsGoal}%` : "0%",
          changely: distributorData?.distributorInventoryTurnovers?.items?.cMvsLM ? `${distributorData?.distributorInventoryTurnovers?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: distributorData?.distributorInventoryTurnovers?.items?.cQvsGoal ? `${distributorData?.distributorInventoryTurnovers?.items?.cQvsGoal}%` : "0%",
          changely: distributorData?.distributorInventoryTurnovers?.items?.cQvsLQ ? `${distributorData?.distributorInventoryTurnovers?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: distributorData?.distributorInventoryTurnovers?.items?.cYvsGoal ? `${distributorData?.distributorInventoryTurnovers?.items?.cYvsGoal}%` : "0%",
          changely: distributorData?.distributorInventoryTurnovers?.items?.cYvsLY ? `${distributorData?.distributorInventoryTurnovers?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.currentYear)}M`,
          status: "increase",
          title: "Year",
          lyValue: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Available Physical Stock (Cases)",
      values: [
        {
          label: "MTD",
          change: distributorData?.distributorAvailablePhysicalStocks?.items?.cMvsGoal ? `${distributorData?.distributorAvailablePhysicalStocks?.items?.cMvsGoal}%` : "0%",
          changely: distributorData?.distributorAvailablePhysicalStocks?.items?.cMvsLM ? `${distributorData?.distributorAvailablePhysicalStocks?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: distributorData?.distributorAvailablePhysicalStocks?.items?.cQvsGoal ? `${distributorData?.distributorAvailablePhysicalStocks?.items?.cQvsGoal}%` : "0%",
          changely: distributorData?.distributorAvailablePhysicalStocks?.items?.cQvsLQ ? `${distributorData?.distributorAvailablePhysicalStocks?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: distributorData?.distributorAvailablePhysicalStocks?.items?.cYvsGoal ? `${distributorData?.distributorAvailablePhysicalStocks?.items?.cYvsGoal}%` : "0%",
          changely: distributorData?.distributorAvailablePhysicalStocks?.items?.cYvsLY ? `${distributorData?.distributorAvailablePhysicalStocks?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.currentYear)}M`,
          status: "increase",
          title: "Year",
          lyValue: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Days of Inventory (DOI)",
      values: [
        {
          label: "MTD",
          change: distributorData?.distributorDaysOfInventories?.items?.cMvsGoal ? `${distributorData?.distributorDaysOfInventories?.items?.cMvsGoal}%` : "0%",
          changely: distributorData?.distributorDaysOfInventories?.items?.cMvsLM ? `${distributorData?.distributorDaysOfInventories?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: distributorData?.distributorDaysOfInventories?.items?.cQvsGoal ? `${distributorData?.distributorDaysOfInventories?.items?.cQvsGoal}%` : "0%",
          changely: distributorData?.distributorDaysOfInventories?.items?.cQvsLQ ? `${distributorData?.distributorDaysOfInventories?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: distributorData?.distributorDaysOfInventories?.items?.cYvsGoal ? `${distributorData?.distributorDaysOfInventories?.items?.cYvsGoal}%` : "0%",
          changely: distributorData?.distributorDaysOfInventories?.items?.cYvsLY ? `${distributorData?.distributorDaysOfInventories?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.currentYear)}M`,
          status: "increase",
          title: "Year",
          lyValue: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Total Number of Deliveries",
      values: [
        {
          label: "MTD",
          change: distributorData?.distributorTotalNumberOfDeliveries?.items?.cMvsGoal ? `${distributorData?.distributorTotalNumberOfDeliveries?.items?.cMvsGoal}%` : "0%",
          changely: distributorData?.distributorTotalNumberOfDeliveries?.items?.cMvsLM ? `${distributorData?.distributorTotalNumberOfDeliveries?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: distributorData?.distributorTotalNumberOfDeliveries?.items?.cQvsGoal ? `${distributorData?.distributorTotalNumberOfDeliveries?.items?.cQvsGoal}%` : "0%",
          changely: distributorData?.distributorTotalNumberOfDeliveries?.items?.cQvsLQ ? `${distributorData?.distributorTotalNumberOfDeliveries?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: distributorData?.distributorTotalNumberOfDeliveries?.items?.cYvsGoal ? `${distributorData?.distributorTotalNumberOfDeliveries?.items?.cYvsGoal}%` : "0%",
          changely: distributorData?.distributorTotalNumberOfDeliveries?.items?.cYvsLY ? `${distributorData?.distributorTotalNumberOfDeliveries?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.currentYear)}M`,
          status: "increase",
          title: "Year",
          lyValue: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
  ];

  //second section cards
  const timeSeriesCardsdata = [
    {
      title: "Reported Dollars Sold",
      values: [
        {
          label: lastYearSameMonth,
          change: distributorData?.distributorReportedDollarSolds?.items?.cmcYvsCMLY ? `${truncateDecimal(distributorData?.distributorReportedDollarSolds?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: distributorData?.distributorReportedDollarSolds?.items?.cMvsLM ? `${truncateDecimal(distributorData?.distributorReportedDollarSolds?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedDollarSolds?.items?.lastMonth)}M`,
          status: "increase",
          arrow: "left",
        },
      ],
    },
    {
      title: "Reported Units Sold (Cases)",
      values: [
        {
          label: lastYearSameMonth,
          change: distributorData?.distributorReportedUnitsSolds?.items?.cmcYvsCMLY ? `${truncateDecimal(distributorData?.distributorReportedUnitsSolds?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: distributorData?.distributorReportedUnitsSolds?.items?.cMvsLM ? `${truncateDecimal(distributorData?.distributorReportedUnitsSolds?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorReportedUnitsSolds?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "Inventory Turnover (Units)",
      values: [
        {
          label: lastYearSameMonth,
          change: distributorData?.distributorInventoryTurnovers?.items?.cmcYvsCMLY ? `${truncateDecimal(distributorData?.distributorInventoryTurnovers?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: distributorData?.distributorInventoryTurnovers?.items?.cMvsLM ? `${truncateDecimal(distributorData?.distributorInventoryTurnovers?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorInventoryTurnovers?.items?.lastMonth)}M`,
          status: "increase",
          arrow: "left",
        },
      ],
    },
    {
      title: "Stock Amount (Cases)",
      values: [
        {
          label: lastYearSameMonth,
          change: distributorData?.distributorAvailablePhysicalStocks?.items?.cmcYvsCMLY ? `${truncateDecimal(distributorData?.distributorAvailablePhysicalStocks?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: distributorData?.distributorAvailablePhysicalStocks?.items?.cMvsLM ? `${truncateDecimal(distributorData?.distributorAvailablePhysicalStocks?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorAvailablePhysicalStocks?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "Days of Inventory (DOI)",
      values: [
        {
          label: lastYearSameMonth,
          change: distributorData?.distributorDaysOfInventories?.items?.cmcYvsCMLY ? `${truncateDecimal(distributorData?.distributorDaysOfInventories?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: distributorData?.distributorDaysOfInventories?.items?.cMvsLM ? `${truncateDecimal(distributorData?.distributorDaysOfInventories?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorDaysOfInventories?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "Total Number of Deliveries",
      values: [
        {
          label: lastYearSameMonth,
          change: distributorData?.distributorTotalNumberOfDeliveries?.items?.cmcYvsCMLY ? `${truncateDecimal(distributorData?.distributorTotalNumberOfDeliveries?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: distributorData?.distributorTotalNumberOfDeliveries?.items?.cMvsLM ? `${truncateDecimal(distributorData?.distributorTotalNumberOfDeliveries?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(distributorData?.distributorTotalNumberOfDeliveries?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
  ];

  const highlightCards = [
    // ------------------ SUB BRAND ------------------
    {
      title: "#1 SKU with Lowest Days of Inventory",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[0]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[0]?.netSales)}M`,
      bigTitle: distributorData?.distributorSKULowestDaysOfInventory?.items[0]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[0]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#2 SKU with Lowest Days of Inventory",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[1]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[1]?.netSales)}M`,
      bigTitle: distributorData?.distributorSKULowestDaysOfInventory?.items[1]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[1]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#3 SKU with Lowest Days of Inventory",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[2]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[2]?.netSales)}M`,
      bigTitle: distributorData?.distributorSKULowestDaysOfInventory?.items[2]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorSKULowestDaysOfInventory?.items[2]?.lastPeriodNetSales)}M`,
    },

    // ------------------ SKU BY UNIT SALES ------------------
    {
      title: "#1 Retailer by Unit Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[0]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[0]?.netSales)}M`,
      bigTitle: distributorData?.distributorRetailerByUnitSales?.items[0]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[0]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#2 Retailer by Unit Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[1]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[1]?.netSales)}M`,
      bigTitle: distributorData?.distributorRetailerByUnitSales?.items[1]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[1]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#3 Retailer by Unit Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[2]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[2]?.netSales)}M`,
      bigTitle: distributorData?.distributorRetailerByUnitSales?.items[2]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorRetailerByUnitSales?.items[2]?.lastPeriodNetSales)}M`,
    },

    // ------------------ STATE BY UNIT SALES ------------------
    {
      title: "#1 Sub Brand by Unit Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[0]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[0]?.netSales)}M`,
      bigTitle: distributorData?.distributorReportedUnitSalesBySubBrand?.items[0]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[0]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#2 Sub Brand by Unit Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[1]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[1]?.netSales)}M`,
      bigTitle: distributorData?.distributorReportedUnitSalesBySubBrand?.items[1]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[1]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#3 Sub Brand by Unit Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[2]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[2]?.netSales)}M`,
      bigTitle: distributorData?.distributorReportedUnitSalesBySubBrand?.items[2]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(distributorData?.distributorReportedUnitSalesBySubBrand?.items[2]?.lastPeriodNetSales)}M`,
    },
  ];

  const getSubBrandColors = (label) => {
    const colorMap = {
      "C4 Powder": "#C2CF2D",
      "C4 Smart Energy": "#1BA4E6",
      "C4 Ultimate": "#1A1A1A",
      "Cellucor": "#747474",
      "XTEND": "#C5C5C5",
      "Bloom Sparkling Energy": "#C393E4",
      "Bloom Pop": "#59A671",
      "C4 Performance": "#ECD01C",
    };

    return colorMap[label] || "#000000"; // fallback color
  };

  const unitsbysubrands = useMemo(() => {
    const items = distributorData?.distributorReportedUnitSalesBySubBrand?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getSubBrandColors(item.name),
    }));
  }, [distributorData]);

  const unitsBySubBrand = [
    { label: "C4 Powder", value: 8, color: "#C2CF2D" },
    { label: "C4 Smart Energy", value: 5, color: "#1BA4E6" },
    { label: "C4 Ultimate", value: 6, color: "#1A1A1A" },
    { label: "Cellucor", value: 10, color: "#747474" },
    { label: "XTEND", value: 8, color: "#C5C5C5" },
    { label: "Bloom Sparkling Energy", value: 12, color: "#C393E4" },
    { label: "Bloom Pop", value: 6, color: "#59A671" },
    { label: "C4 Performance", value: 45, color: "#ECD01C" },
  ];
  const getRegionColor = (label) => {
    console.log(label, "^^^^");

    const colorMap = {
      North: "#B5CBEA",
      South: "#9B72C2",
      "South Central": "#FFC081",
      West: "#3BA73B",
      Central: "#DEDE96",
    };

    return colorMap[label] || "#000000"; // fallback color
  };
  const unitsByRegion = useMemo(() => {
    const items = distributorData?.distributorReportedUnitSalesByRegion?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getRegionColor(item.name),
    }));
  }, [distributorData]);


  const getRetailerColor = (label) => {
    console.log(label, "^^^^")
    const colorMap = {
      "Walmart": "#1F5FD6",
      "Target": "#E10600",
      "Sam's Club": "#0E4A7B",
      "Kroger": "#6DBF45",
      "Other": "#000000",
      "7-Eleven": "#E6A700",
    };

    return colorMap[label] || "#000000"; // fallback color
  };
  const unitbyretailers = useMemo(() => {
    const items = distributorData?.distributorRetailerByUnitSales?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getRetailerColor(item.name),
    }));
  }, [distributorData]);

  const getChannelColor = (label) => {
    console.log(label, "^^^^");

    const colorMap = {
      "Mass": "#0B6BD3",
      "Grocery": "#4CAF50",
      "Drug": "#E10600",
      "Club": "#0E4A7B",
      "Other": "#000000",
      "Convenience Independent": "#F57C21",
    };

    return colorMap[label] || "#000000"; // fallback color
  };
  const unitsByChannel = useMemo(() => {
    const items = distributorData?.distributorReportedUnitSalesByChannel?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getChannelColor(item.name),
    }));
  }, [distributorData]);

  const getSubBrandColor = (name) => {
    const colorMap = {
      "C4 Performance": "#ECD01C",
      "C4 Smart Energy": "#1BA4E6",
      "C4 Ultimate": "#1A1A1A",
      "Bloom Sparkling Energy": "#C393E4",
      "Bloom Pop": "#59A671",
    };

    return colorMap[name] || "#000000";
  };

  const lineChartSubBrandDatas = useMemo(() => {
    const items = distributorData?.distributorReportedUnitsSoldSubBrandMonthly?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    // Sort months chronologically
    const sortedItems = [...items].sort((a, b) => {
      return new Date(a.month) - new Date(b.month);
    });

    // Format month labels (e.g., "January-2025" → "Jan. 2025")
    const formatMonth = (monthStr) => {
      const date = new Date(monthStr);
      const month = date.toLocaleString("en-US", { month: "short" });
      const year = date.getFullYear();
      return `${month}. ${year}`;
    };

    const xLabels = sortedItems.map((item) => formatMonth(item.month));

    // Extract unique subBrands
    const subBrands = [...new Set(sortedItems.flatMap((item) => item.values.map((v) => v.subBrandName)))];

    const series = subBrands.map((name) => ({
      label: name,
      color: getSubBrandColor(name),
    }));
    // Build dataMatrix.actual
    const actual = sortedItems.map((item) => {
      return subBrands.map((brand) => {
        const found = item.values.find((v) => v.subBrandName === brand);
        return found ? found.casesOrdered : 0;
      });
    });
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues);

    const step = Math.ceil(maxValue / 5);
    const yTicks = Array.from({ length: 6 }, (_, i) => i * step);

    return {
      title: "Reported Units Sold by Sub-Brand",
      xLabels,
      series,
      yTicks,
      dataMatrix: {
        actual,
      },
    };
  }, [distributorData]);
  console.log(lineChartSubBrandDatas, "lineChartSubBrandDatas");


  const topSkuUnitsChartDatas = {
    title: "Top 10 Ordered SKUs by Reported Units Sold",

    xLabels: ["C4 Performance – Frozen Bombsicle – 12pk", "C4 Performance – Orange Slice – 12pk", "C4 Performance – Strawberry Watermelon – 12pk", "C4 Performance – Tropical Blast – 12pk", "C4 Smart Energy – Blood Orange Yuzu – 12pk", "C4 Ultimate – Midnight Cherry – 12pk", "C4 Ultimate – Tropic Storm – 24pk", "C4 Ultimate – Neon Mango – 24pk", "C4 Performance – Strawberry Watermelon – 12pk", "C4 Performance – Lemon Frost – 24pk"],

    series: [
      { label: "Units Sold - This Period", key: "thisPeriod", color: "#0A3478" },
      { label: "Units Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" },
    ],

    dataMatrix: {
      actual: [
        [3.8, 1.7], // Frozen Bombsicle – 12pk
        [3.3, 1.1], // Orange Slice – 12pk
        [3.1, 1.3], // Strawberry Watermelon – 12pk
        [2.9, 0.5], // Tropical Blast – 12pk
        [2.6, 1.2], // Blood Orange Yuzu – 12pk
        [2.3, 0.5], // Midnight Cherry – 12pk
        [2.1, 1.2], // Tropic Storm – 24pk
        [1.9, 1.5], // Neon Mango – 24pk
        [1.8, 0.7], // Strawberry Watermelon – 12pk
        [1.4, 0.6], // Lemon Frost – 24pk
      ],
    },
  };
  const topSkuUnitsChartData = useMemo(() => {
    const items = distributorData?.distributorTop10OrderedSKUs?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    const normalizeUnits = (val) => {
      if (val == null || val === "-") return 0;
      return Number((Number(val) / 1000).toFixed(1));
    };

    // ---- X Labels (categories)
    const xLabels = items.map(item => item.sku);
    // ---- Data Matrix
    const actual = items.map(item => [
      normalizeUnits(item.value),
      0
    ]);

    // ---- Y-axis ticks (numeric scaling)
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues);

    const tickStep = Math.ceil(maxValue / 5);
    const xTicks = Array.from({ length: 6 }, (_, i) => i * tickStep);

    return {
      title: "Top 10 Ordered SKUs by Reported Units Sold",

      xLabels,
      xTicks,

      series: [
        { label: "Units Sold - This Period", key: "thisPeriod", color: "#0A3478" },
        { label: "Units Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" },
      ],

      dataMatrix: { actual },
    };
  }, [distributorData]);


  console.log(topSkuUnitsChartData, "topSkuUnitsChartData")

  const bottomSkuUnitsChartDatas = {
    title: "Bottom 10 SKUs by Reported Units Sold",

    xLabels: ["Bloom Pop – Tropical Citrus – 24pk", "Bloom Pop – Blue Razz – 12pk", "Bloom Pop – Strawberry – 24pk", "Bloom Sparkling – Mango – 24pk", "Bloom Sparkling – Pineapple – 24pk", "C4 Ultimate – Blue Ice – 12pk", "C4 Smart Energy – Blackberry Citrus – 12pk", "C4 Smart Energy – Strawberry Guava – 24pk", "C4 Smart Energy – Kiwi Lime – 12pk", "C4 Performance – Grape Burst – 24pk"],

    series: [
      { label: "Units Sold - This Period", key: "thisPeriod", color: "#0A3478" },
      { label: "Units Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" },
    ],

    dataMatrix: {
      actual: [
        [2, 6], // Bloom Pop – Tropical Citrus
        [3, 5], // Bloom Pop – Blue Razz
        [6, 12], // Bloom Pop – Strawberry
        [9, 11], // Bloom Sparkling – Mango
        [13, 9], // Bloom Sparkling – Pineapple
        [17, 19], // C4 Ultimate – Blue Ice
        [20, 24], // C4 Smart Energy – Blackberry Citrus
        [23, 19], // C4 Smart Energy – Strawberry Guava
        [27, 22], // C4 Smart Energy – Kiwi Lime
        [31, 24], // C4 Performance – Grape Burst
      ],
    },
  };
  const bottomSkuUnitsChartData = useMemo(() => {
    const items = distributorData?.distributorBottom10OrderedSKUs?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    const normalizeUnits = (val) => {
      if (val == null || val === "-") return 0;
      return Number((Number(val) / 1000).toFixed(1));
    };

    // ---- X Labels (categories)
    const xLabels = items.map(item => item.sku);

    // ---- Data Matrix
    const actual = items.map(item => [
      normalizeUnits(item.value),
      0 // Backend doesn't provide last period yet
    ]);

    // ---- Same numeric tick logic you used in Top 10 (kept identical)
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues);

    const tickStep = Math.ceil(maxValue / 5);
    const xTicks = Array.from({ length: 6 }, (_, i) => i * tickStep);

    return {
      title: "Bottom 10 SKUs by Reported Units Sold",

      xLabels,
      xTicks,

      series: [
        { label: "Units Sold - This Period", key: "thisPeriod", color: "#0A3478" },
        { label: "Units Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" },
      ],

      dataMatrix: {
        actual,
      },
    };
  }, [distributorData]);


  const getInventoryColor = (key) => {
    const colorMap = {
      casesInStock: "#9B4DFF",
      casesOrdered: "#56BC4C",
      casesSold: "#E16363",
    };

    return colorMap[key] || "#000000";
  };

  const inventoryChartDatas = useMemo(() => {
    const items = distributorData?.distributorCasesOverTimes?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    //Sort months chronologically
    const sortedItems = [...items].sort((a, b) => new Date(a.month) - new Date(b.month));

    //Format month label (Apr-2025 → Apr. 2025)
    const formatMonth = (monthStr) => {
      const date = new Date(monthStr);
      const month = date.toLocaleString("en-US", { month: "short" });
      const year = date.getFullYear();
      return `${month}. ${year}`;
    };

    const xLabels = sortedItems.map((item) => formatMonth(item.month));

    //Series configuration
    const seriesConfig = [
      { key: "casesInStock", label: "Cases in Stock", type: "line" },
      { key: "casesOrdered", label: "Cases Ordered", type: "bar" },
      { key: "casesSold", label: "Cases Sold", type: "bar" },
    ];

    const series = seriesConfig.map((item) => ({
      ...item,
      color: getInventoryColor(item.key),
    }));

    //Build Data Matrix
    const dataMatrix = sortedItems.map((item) => [Number(item.casesInStock?.toFixed(2)) || 0, Number(item.casesOrdered?.toFixed(2)) || 0, Number(item.casesSold?.toFixed(2)) || 0]);

    //Dynamic Y Ticks
    const allValues = dataMatrix.flat();
    const maxValue = Math.max(...allValues);

    const niceMax = Math.ceil(maxValue / 1000) * 1000; // round nicely
    const step = niceMax / 5;

    const yTicks = Array.from({ length: 6 }, (_, i) => Number((i * step).toFixed(2)));

    return {
      title: "Distributor Cases In Stock Over Time",
      xLabels,
      series,
      dataMatrix,
      yTicks,
    };
  }, [distributorData]);
  console.log(inventoryChartDatas, "inventoryChartDatas***");
  const inventoryChartData = {
    title: "Distributor Cases In Stock Over Time",

    xLabels: ["Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025", "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025", "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"],

    series: [
      { key: "casesInStock", label: "Cases in Stock", type: "line", color: "#9B4DFF" },
      { key: "casesOrdered", label: "Cases Ordered", type: "bar", color: "#56BC4C" },
      { key: "casesSold", label: "Cases Sold", type: "bar", color: "#E16363" },
    ],

    // Units = Millions (M)
    dataMatrix: [
      // [Cases in Stock, Cases Ordered, Cases Sold]
      [1.51, 0.75, 1.1], // Dec
      [1.62, 0.62, 0.92], // Jan
      [1.75, 0.92, 0.8], // Feb
      [1.7, 1.0, 0.8], // Mar
      [1.9, 0.6, 0.82], // Apr
      [1.95, 1.2, 0.9], // May
      [2.4, 0.9, 1.05], // Jun
      [2.3, 1.1, 0.75], // Jul
      [2.35, 0.9, 1.1], // Aug
      [2.2, 0.9, 1.1], // Sep
      [2.05, 1.05, 1.15], // Oct
      [2.0, 0.9, 0.6], // Nov
    ],
    yTicks: [0, 0.5, 1.0, 1.5, 2.0, 2.5],
  };
  const getOTIFColor = (label) => {
    const colorMap = {
      "Perfect Order Rate (OTIF)": "#0B5ED7",
      "On Time Delivery (OT)": "#00A86B",
      "Order Fill Rate (IF)": "#FF8C42",
    };

    return colorMap[label] || "#000000";
  };
  const overtime = useMemo(() => {
    const items = distributorData?.distributorOTIFOverTimes?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    // Sort months chronologically
    const sortedItems = [...items].sort((a, b) => new Date(a.month) - new Date(b.month));

    //Format month (Apr-2025 → Apr. 2025)
    const formatMonth = (monthStr) => {
      const date = new Date(monthStr);
      const month = date.toLocaleString("en-US", { month: "short" });
      const year = date.getFullYear();
      return `${month}. ${year}`;
    };

    const xLabels = sortedItems.map((item) => formatMonth(item.month));

    //Series Configuration
    const seriesConfig = [
      { label: "Perfect Order Rate (OTIF)", key: "perfectOrderRate" },
      { label: "On Time Delivery (OT)", key: "onTimeDelivery" },
      { label: "Order Fill Rate (IF)", key: "orderFillRate" },
    ];

    const series = seriesConfig.map((item) => ({
      label: item.label,
      color: getOTIFColor(item.label),
    }));

    // Build Data Matrix
    const dataMatrix = sortedItems.map((item) => [Number(item.perfectOrderRate?.toFixed(2)) || 0, Number(item.onTimeDelivery?.toFixed(2)) || 0, Number(item.orderFillRate?.toFixed(2)) || 0]);

    //Dynamic Y Ticks (Percentage Style)
    const allValues = dataMatrix.flat();
    const maxValue = Math.max(...allValues);
    const minValue = Math.min(...allValues);

    const niceMin = Math.floor(minValue / 5) * 5;
    const niceMax = Math.ceil(maxValue / 5) * 5;

    const step = (niceMax - niceMin) / 5;

    const yTicks = Array.from({ length: 6 }, (_, i) => Math.round(niceMin + i * step));

    return {
      title: "OTIF, OT, and IF Over Time",
      xLabels,
      series,
      dataMatrix,
      yTicks,
    };
  }, [distributorData]);
  console.log(overtime, "overtimes**");
  const overtimes = {
    title: "OTIF, OT, and IF Over Time",
    xLabels: ["Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025", "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025", "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"],
    series: [
      {
        label: "Perfect Order Rate (OTIF)",
        color: "#0B5ED7",
      },
      {
        label: "On Time Delivery (OT)",
        color: "#00A86B",
      },
      {
        label: "Order Fill Rate (IF)",
        color: "#FF8C42",
      },
    ],
    dataMatrix: [
      [89, 93, 90],
      [83, 97, 88],
      [86, 95, 90],
      [88, 97, 94],
      [87, 98, 89],
      [86, 96, 91],
      [84, 96, 94],
      [86, 93, 88],
      [85, 94, 92],
      [86, 96, 94],
      [85, 96, 89],
      [89, 97, 91],
    ],
    yTicks: [75, 80, 85, 90, 95, 100],
  };

  return (
    <DashboardLayout>
      <MDBox
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "none",
          },
        }}
      >
        <AppHeader />
      </MDBox>
      <Box
        sx={{
          position: "sticky", // better than fixed
          top: 0,
          zIndex: 10,
          bottom: 0,
          // background: "red",
        }}
      >
        <Box
          sx={{
            ml: 0,
            transition: "margin-left 0.25s ease",
            "& .MuiBox-root": { backgroundImage: "none" },
          }}
          style={{
            // backgroundColor: '#f8f9fa',
            minHeight: "100vh",
            padding: isMobile ? "8px" : "0px 16px 100px 16px",
            paddingBottom: "100px",
            fontFamily: "inter",
          }}
        >
          {/* Loading Backdrop */}
          <Backdrop
            open={loading}
            sx={{
              position: "fixed",
              zIndex: (theme) => theme.zIndex.drawer + 1,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <CircularProgress color="primary" />
          </Backdrop>

          {/* Header */}
          <Box style={{ display: "flex", alignItems: "center", height: "68px", background: "none" }}>
            <Box sx={{ background: "none" }}>
              <Box sx={{ width: 48, height: 48, borderRadius: "50%", boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.12)" }}>{/* <img src={Banner1} alt="Retailer Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} /> */}</Box>
            </Box>
            <Box sx={{ ml: "10px" }}>
              <Box sx={{ background: "none", display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontSize: "24px", fontWeight: 300, color: "#111111", lineHeight: "1 !important" }}>
                  {selectedItem?.distributorName || ""} ({selectedItem?.coverage || ""})
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "rgba(17, 17, 17, 0.5)", fontWeight: 300, lineHeight: "1 !important" }}>{selectedItem?.regionsServed || ""}</Typography>
              </Box>
            </Box>
            <Box sx={{ ml: "4px" }}>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    bgcolor: "#25A73E",
                    boxShadow: "0px 0px 4px rgba(16, 125, 37, 0.5)",
                    mt: "-8px",

                    // marginTop: "1.2rem"
                  }}
                />
              </Box>
            </Box>
          </Box>
          {/* Blue Underline */}
          <Box
            sx={{
              width: "100%",
              height: "4px",
              background: "#115f9d",
              borderRadius: "0px",
              mb: 0,
              width: "calc(100% + 80px)",
              ml: "-40px",
              mr: "-40px",
              position: "relative",
              zIndex: 11,
            }}
            className="gradient-line-Distributors"
          />

          <Box
            sx={{
              height: "calc(100vh - 80px)", // adjust if header height changes
              overflowY: "auto",
              // px: isMobile ? 1 : 2,
              pb: "100px",
              /* smooth scrolling */
              scrollBehavior: "smooth",
              WebkitOverflowScrolling: "touch", // iOS momentum

              /* hide scrollbar */
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE / Edge
              "&::-webkit-scrollbar": {
                display: "none", // Chrome / Safari
              },
            }}
          >
            {/* Section Title: KPI's */}
            <Typography sx={{ mb: 1, mt: 3, display: "flex", gap: "4px", alignItems: "center" }}>
              <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>Distributors / </span>{" "}
              <span style={{ fontSize: "16px", fontWeight: 200 }}>
                {selectedItem?.distributorName || ""} ({selectedItem?.coverage || ""}) ({selectedItem?.color || ""})
              </span>
            </Typography>
            <Box sx={{ width: "100%", height: "1px", background: "rgba(22, 114, 185, 0.1)", borderRadius: "2px", mb: 2 }} />
            <Box sx={{ minHeight: "auto" }}>
              <Grid container rowSpacing={2}>
                {/* LEFT CARD – responsive */}
                <Grid
                  item
                  xs={12}
                  md={3}
                  sx={{
                    pl: "8px !important", // REQUIRED
                  }}
                >
                  {accordionData.map((item, index) => (
                    <Accordion
                      key={index}
                      expanded={expanded === `panel${index}`}
                      onChange={handleChange(`panel${index}`)}
                      elevation={0}
                      sx={{
                        borderRadius: "12px !important",
                        overflow: "hidden",
                        mb: 2,
                        boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {/* HEADER */}
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#A7B2BE" }} />}
                        sx={{
                          bgcolor: "#fff",
                          // borderBottom: "1px solid #f1f1f1",
                          // remove default height
                          minHeight: "unset",

                          //exact vertical padding
                          paddingTop: "16px",
                          paddingBottom: "24PX",
                          px: "20px",

                          // FIX inner content spacing
                          "& .MuiAccordionSummary-content": {
                            margin: 0,
                          },

                          // also fix expanded state
                          "&.Mui-expanded": {
                            minHeight: "unset",
                          },
                          "&.Mui-expanded .MuiAccordionSummary-content": {
                            margin: 0,
                          },
                        }}
                      >
                        <Typography sx={{ color: "#1672B9", fontWeight: 200, fontSize: 16 }}>{item.title}</Typography>
                      </AccordionSummary>
                      {/* CONTENT */}
                      <AccordionDetails sx={{ px: 2.5, pb: "20px", pt: 0, marginBottom: miniSidenav ? "15.1rem !important" : "15.3rem !important", bgcolor: "#fff" }}>
                        <Box>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Regions Served</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>Central, North, South, South Central, West</Typography>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>States Served</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>AL, AR, AZ, CA, CO, FL, GA, IA, IL, IN, KS, KY, LA, MI, MO, MS, NC, NE, NM, NV, OH, OK, OR, PA, SC, SD, TN, TX, VA, WA</Typography>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Assignment Type</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.AssignmentType}</Typography>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>KDP Flag</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.KDPFlag}</Typography>
                          {/* Number Of Doors */}
                          <Typography sx={{ color: "#A7B2BE", fontSize: 10, fontWeight: 200 }}>Number Of Doors</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200 }}>{item.doors}</Typography>
                          {/* Status */}
                          <Typography sx={{ color: "#11111180", fontSize: 10, fontWeight: 200 }}>Status</Typography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography sx={{ fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.status}</Typography>
                            {item.status === "Active" && (
                              <Box
                                sx={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "50%",
                                  bgcolor: "#25A73E",
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{
                    pl: 2,
                    pr: "8px !important", // REQUIRED
                  }}
                >
                  <Grid container spacing={2}>
                    {/* TOP ROW – 4 Cards */}
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        {metricData.map((item, index) => (
                          <Grid item xs={12} sm={6} lg={3} key={index}>
                            <Card
                              sx={{
                                width: "100%",
                                borderRadius: "12px",
                                padding: "12px 8px 12px 16px",
                                height: miniSidenav ? "auto" : "auto",
                                boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                                display: "flex",
                                flexDirection: "row",
                                border: "none !important",
                                // gap: "6px"
                              }}
                            >
                              <Box sx={{ width: miniSidenav ? "80%" : "82%" }}>
                                <Typography
                                  sx={{
                                    fontSize: miniSidenav ? 12 : 13,
                                    fontWeight: 300,
                                    color: "#1672B9",
                                    minHeight: miniSidenav ? "auto" : "auto",
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Box>
                                  <Typography sx={{ fontSize: 32, fontWeight: 500, lineHeight: 1, mt: "6px !important", color: "#111111" }}>{item.value}</Typography>
                                  {/* Growth Row */}
                                  <Box sx={{ display: "flex", alignItems: "center", mt: "6px !important" }}>
                                    <Chip
                                      icon={<ArrowDropUpIcon />}
                                      label={`${item.growth}`}
                                      sx={{
                                        background: "rgba(0, 143, 12, 0.25)",
                                        color: "#008F0C",
                                        fontWeight: 400,
                                        height: 20,
                                        mr: "6px",
                                        border: "1px solid rgba(0, 143, 12, 0.25)",

                                        /* IMPORTANT: remove default padding */
                                        padding: 0,

                                        /* Chip root controls left/right breathing space */
                                        "& .MuiChip-root": {
                                          padding: 0,
                                        },

                                        /* ICON */
                                        "& .MuiChip-icon": {
                                          fontSize: 16,
                                          color: "#008F0C",
                                          marginLeft: "8px", //left space
                                          marginRight: "4px", //space between icon & value
                                        },

                                        /* LABEL */
                                        "& .MuiChip-label": {
                                          paddingLeft: "0px !important",
                                          paddingRight: "8px !important", //right space
                                          fontSize: 10,
                                          fontWeight: 300,
                                          lineHeight: 1,
                                        },
                                      }}
                                    />

                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        color: "rgba(17, 17, 17, 0.25)",
                                        fontWeight: 300,
                                      }}
                                    >
                                      YTD
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              <Box sx={{ width: miniSidenav ? "20%" : "18%", display: "flex", alignItems: "flex-start", justifyContent: "flex-end" }}>
                                <IconButton
                                  size="small"
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: "50%",
                                    border: "1.5px solid rgba(22, 114, 185, 0.25)",
                                  }}
                                >
                                  <ArrowOutwardIcon sx={{ fontSize: 16, color: "rgba(22, 114, 185, 0.25)" }} />
                                </IconButton>
                              </Box>
                              {/* Top Row: Title + Arrow */}
                              {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                                                            <Typography
                                                                                                                sx={{
                                                                                                                    fontSize: 13,
                                                                                                                    fontWeight: 600,
                                                                                                                    color: "#1672B9",
                                                                                                                }}
                                                                                                            >
                                                                                                                {item.title}
                                                                                                            </Typography>
                                                                                                            <IconButton
                                                                                                                size="small"
                                                                                                                sx={{
                                                                                                                    width: 32,
                                                                                                                    height: 32,
                                                                                                                    borderRadius: "50%",
                                                                                                                    border: "1px solid rgba(22, 114, 185, 0.25)",
                                                                                                                }}
                                                                                                            >
                                                                                                                <ArrowOutwardIcon sx={{ fontSize: 16, color: "rgba(22, 114, 185, 0.25)" }} />
                                                                                                            </IconButton>
                                                                                                        </Box> */}
                              {/* Bottom Stats */}
                              {/* <Box>
                                                                                                            <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
                                                                                                                {item.value}
                                                                                                            </Typography>
                                                                                                        
                                                                                                            <Box sx={{ display: "flex", alignItems: "center", mt: '6px !important' }}>
                                                                                                                <Chip
                                                                                                                    icon={<ArrowDropUpRoundedIcon />}
                                                                                                                    label={`${item.growth}`}
                                                                                                                    sx={{
                                                                                                                        background: "rgba(0, 143, 12, 0.25)", // 25% opacity
                                                                                                                        color: "#008F0C",
                                                                                                                        fontWeight: 600,
                                                                                                                        height: 24,
                                                                                                                        mr: "6px",
                                                                                                                        border: "1px solid rgba(0, 143, 12, 0.25)",
                                                                                                                        // FIX: override chip icon styles
                                                                                                                        "& .MuiChip-icon": {
                                                                                                                            fontSize: "22px !important",      // icon size
                                                                                                                            color: "#008F0C",
                                                                                                                            marginLeft: '8px'
                                                                                                                        },
                                                                                                                        "& .MuiChip-label": {
                                                                                                                            paddingLeft: "4px !important",
                                                                                                                            paddingRight: "8px !important"
                                                                                                                        }
                                                                                                                    }}
                                                                                                                />
                                                                                                                <Typography sx={{ fontSize: 10, color: "rgba(17, 17, 17, 0.25)" }}>YTD</Typography>
                                                                                                            </Box>
                                                                                                        </Box> */}
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>

                    {/* BOTTOM FULL WIDTH */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          borderRadius: "12px",
                          p: 2,
                          bgcolor: "#fff",
                          boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                          border: "none !important",
                        }}
                      >
                        <Grid container spacing={2}>
                          {/* ---------- MAP 1 SECTION ---------- */}
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                color: "#2B9BE3",
                                fontWeight: 300,
                                fontSize: 14,
                                mb: 1.5,
                              }}
                            >
                              Distributor Coverage Map
                            </Typography>

                            {/* <Box sx={{ height: 500, borderRadius: 2, overflow: "hidden" }}>
                                                                <iframe
                                                                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d26273994.225374334!2d-102.011!3d39.77!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000000"
                                                                    width="100%"
                                                                    height="100%"
                                                                    style={{ border: 0 }}
                                                                    allowFullScreen=""
                                                                    loading="lazy"
                                                                ></iframe>
                                                            </Box> */}
                            <StateCountyCoverageMap />
                          </Grid>

                          {/* ---------- TABLE SECTION ---------- */}
                          <Grid item xs={12} md={6}>
                            <Box sx={{ height: 500, overflowY: "auto", overflowX: "auto", mt: 4.5 }}>
                              {/* Header Row */}
                              <Box sx={{ display: "flex", borderBottom: "1px solid #1672B91A", position: "sticky", top: 0, bgcolor: "#fff", zIndex: 1 }}>
                                {/* <Box sx={{ flex: "0 0 80px", p: 1, fontWeight: 600, fontSize: 13 }}>Region</Box> */}
                                <Box sx={{ flex: "0 0 120px", p: 1, fontWeight: 600, fontSize: 13 }}>State</Box>
                                <Box sx={{ flex: "0 0 120px", p: 1, fontWeight: 600, fontSize: 13 }}>County</Box>
                                {/* <Box sx={{ flex: "0 0 100px", p: 1, fontWeight: 600, fontSize: 13 }}>Zip Code</Box> */}
                                <Box sx={{ flex: "0 0 120px", p: 1, fontWeight: 600, fontSize: 13 }}>No. of Stores</Box>
                              </Box>
                              {/* Data Rows */}
                              {formateddata.map((row, index) => (
                                <Box
                                  key={index}
                                  sx={{
                                    display: "flex",
                                    borderBottom: "1px solid #f0f0f0",
                                    "&:hover": { bgcolor: "#f9f9f9" },
                                  }}
                                >
                                  {/* <Box sx={{ flex: "0 0 80px", p: 1, fontSize: 13 }}>{row?.region}</Box> */}
                                  <Box sx={{ flex: "0 0 120px", p: 1, fontSize: 13 }}>{row?.stateName}</Box>
                                  <Box sx={{ flex: "0 0 120px", p: 1, fontSize: 13 }}>{row?.County}</Box>
                                  {/* <Box sx={{ flex: "0 0 100px", p: 1, fontSize: 13 }}>{row?.zipCode}</Box> */}
                                  <Box sx={{ flex: "0 0 120px", p: 1, fontSize: 13 }}>{row?.NumberofStores}</Box>
                                </Box>
                              ))}
                            </Box>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            {/* Section Title: KPI's */}

            <Typography sx={{ mt: 3, display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                {selectedItem?.distributorName || ""} ({selectedItem?.color || ""}) /{" "}
              </span>{" "}
              <span style={{ fontSize: "16px", fontWeight: 200 }}>KPI's</span>
            </Typography>
            <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mt: "8px" }} />
            <KpiMetricscards cardsData={Kpiscardsdata} />

            {/* Section Title: Time series */}
            <Typography sx={{ fontSize: "16px", mt: 3, display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                {selectedItem?.distributorName || ""} ({selectedItem?.color || ""}) /{" "}
              </span>
              <span style={{ fontSize: "16px", fontWeight: 200 }}>Time Series</span>
            </Typography>
            <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mt: "8px" }} />
            <TimeSeriescards timeSeriesCards={timeSeriesCardsdata} />

            {/* Section Title: Highlights */}

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "24px" }}>
              <Typography sx={{ fontSize: "16px" }}>
                <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                  {selectedItem?.distributorName || ""} ({selectedItem?.color || ""}) /{" "}
                </span>{" "}
                <span style={{ fontSize: "16px", fontWeight: 200 }}>Highlights</span>
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                {["YTD", "QTD", "MTD"].map((label, idx) => (
                  <FilterChip key={label} label={label} idx={idx} activeIdx={activeIdx} onClick={setActiveIdx} />
                ))}
              </Box>
            </Box>
            <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mt: "8px" }} />
            <HighlightsCards data={highlightCards} />
            <Box sx={{ mt: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                <Typography sx={{ fontSize: "16px" }}>
                  <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                    {selectedItem?.distributorName || ""} ({selectedItem?.color || ""}) /{" "}
                  </span>{" "}
                  <span style={{ fontSize: "16px", fontWeight: 200 }}>Visualizations</span>
                </Typography>

                <Box sx={{ display: "flex", gap: 1 }}>
                  {["YTD", "QTD", "MTD"].map((label, idx) => (
                    <FilterChip key={label} label={label} idx={idx} activeIdx={activeIdx} onClick={setActiveIdx} />
                  ))}
                </Box>
              </Box>

              <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mb: 0 }} />
            </Box>
            {/* Section Title: Visualizations */}
            <Grid
              container
              rowSpacing={2}
              columnSpacing={2}
              sx={{
                mt: "26px !important",
                alignItems: "stretch", // keeps all cards same height
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "0px !important", sm: "0px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Units Sold by Sub Brand" data={unitsbysubrands} />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Unit Sales by Region" data={unitsByRegion} />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Unit Sales by Retailer" data={unitbyretailers} />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Unit Sales by Channel" data={unitsByChannel} />
              </Grid>
            </Grid>
            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                {lineChartSubBrandDatas?.title && lineChartSubBrandDatas?.xLabels?.length > 0 && lineChartSubBrandDatas?.series?.length > 0 && lineChartSubBrandDatas?.dataMatrix?.actual?.length > 0 && <LineChartSubBrand title={lineChartSubBrandDatas.title} xLabels={lineChartSubBrandDatas.xLabels} series={lineChartSubBrandDatas.series} dataMatrix={lineChartSubBrandDatas.dataMatrix} yTicks={lineChartSubBrandDatas.yTicks} />}
              </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ mt: "34px !important" }}>
              {/* LEFT CARD - USA MAP */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  pt: { xs: "0px !important", sm: "0px !important" },
                }}
              >
                {topSkuUnitsChartData && (
                  <TopSkuBarChart
                    title={topSkuUnitsChartData.title}
                    xLabels={topSkuUnitsChartData.xLabels}
                    series={topSkuUnitsChartData.series}
                    dataMatrix={topSkuUnitsChartData.dataMatrix}
                    xTicks={topSkuUnitsChartData.xTicks}
                    valueFormatter={(v) => `${v}M`}
                  />
                )}

              </Grid>

              {/* RIGHT CARD - BAR CHART */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  pt: { xs: "34px !important", sm: "34px !important", md: "0px !important" },
                }}
              >
                {bottomSkuUnitsChartData && (
                  <TopSkuBarChart
                    title={bottomSkuUnitsChartData.title}
                    xLabels={bottomSkuUnitsChartData.xLabels}
                    series={bottomSkuUnitsChartData.series}
                    dataMatrix={bottomSkuUnitsChartData.dataMatrix}
                    xTicks={bottomSkuUnitsChartData.xTicks}
                    valueFormatter={(v) => `${v}K`}
                  />
                )}
              </Grid>
            </Grid>

            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                {inventoryChartDatas?.title && inventoryChartDatas?.xLabels?.length > 0 && inventoryChartDatas?.series?.length > 0 && inventoryChartDatas?.dataMatrix?.length > 0 && <InventoryCharts title={inventoryChartDatas.title} xLabels={inventoryChartDatas.xLabels} series={inventoryChartDatas.series} dataMatrix={inventoryChartDatas.dataMatrix} yTicks={inventoryChartDatas.yTicks} yAxisLabel="Units (M)" valueFormatter={(v) => `${v}M`} />}
              </Grid>
            </Grid>
            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                {overtime?.title && overtime?.xLabels?.length > 0 && overtime?.series?.length > 0 && overtime?.dataMatrix?.length > 0 && <MultiBarcharts title={overtime.title} xLabels={overtime.xLabels} series={overtime.series} dataMatrix={overtime.dataMatrix} yTicks={overtime.yTicks} />}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default DistributorsDetailspage;
